(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      class StickyHeader extends HTMLElement {
        constructor() {
          super();
          this.setHeaderHeight = this.setHeaderHeight.bind(this);
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header');
          if (!this.header) return;

          this.headerIsAlwaysSticky =
            this.getAttribute('data-sticky-type') === 'always' ||
            this.getAttribute('data-sticky-type') === 'reduce-logo-size';

          this.headerBounds = {};
          this.setHeaderHeight();

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);

          window.addEventListener('resize', this.setHeaderHeight);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          }
        }

        setHeaderHeight() {
          if (!this.header) return;
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.setHeaderHeight);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          const observer = new IntersectionObserver((entries) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.headerIsAlwaysSticky) {
              this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            }
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.headerIsAlwaysSticky) {
              this.header.classList.add('shopify-section-header-sticky', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove(
              'scrolled-past-header',
              'shopify-section-header-hidden',
              'shopify-section-header-sticky',
              'animate'
            );
          }

          this.currentScrollTop = scrollTop;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
